import React, { useState } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { Project } from '@leverege/api-redux';
import { Button, Flex, Pane, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { capitalize } from '@leverege/string-util';
import { ns } from '@leverege/i18n';
import Cookies from 'js-cookie';
import S from './MaintenanceReminders.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  tIcon
} = ns('molten.views.maintenance.MaintenanceReminders');
const DATE_FORMAT_STRING = "EEEE MMMM do 'at' p";
class MaintenanceReminders extends React.Component {
  componentDidMount() {
    const {
      dispatch,
      molten
    } = this.props;
    const api = molten.get('api');
    const prjId = api.options.projectId;
    dispatch(Project(prjId).activeMaintenanceEvents().list());
  }
  onDismiss = ({
    data
  }) => {
    Cookies.set(`maintenanceEvent.${data.id}`, 'true', {
      expires: new Date(data.endTime)
    });
    this.forceUpdate();
  };
  render() {
    const {
      maintenanceEvents = []
    } = this.props;
    if (maintenanceEvents.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: S.container,
      children: maintenanceEvents.filter(event => {
        return Cookies.get(`maintenanceEvent.${event.id}`) == null;
      }).map(event => {
        return /*#__PURE__*/_jsx(MaintenanceEvent, {
          event: event,
          onDismiss: this.onDismiss
        }, event.id);
      })
    });
  }
}
function MaintenanceEvent({
  onDismiss,
  event
}) {
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const variant = `maintenanceEvent${capitalize(event.type)}|maintenanceEvent`;
  return /*#__PURE__*/_jsxs(Pane, {
    variant: variant,
    layout: "flex:rowM",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colMStart",
      children: [/*#__PURE__*/_jsxs(Text, {
        variant: variant,
        children: [Config.get('MaintenanceReminders', 'applicationName', 'The application'), " will undergo maintenance from ", format(new Date(event.startTime), DATE_FORMAT_STRING), " until ", format(new Date(event.endTime), DATE_FORMAT_STRING), "."]
      }), event.description && (showMoreInfo ? /*#__PURE__*/_jsx(Text, {
        variant: variant,
        children: event.description
      }) : /*#__PURE__*/_jsx(Button, {
        variant: `${variant}|linkNoPad`,
        onClick: () => setShowMoreInfo(true),
        children: "More information"
      }))]
    }), /*#__PURE__*/_jsx(Button, {
      variant: `${variant}|link`,
      icon: tIcon('closeIcon', 'fa fa-fw fa-close'),
      eventData: event,
      onClick: onDismiss
    })]
  });
}
export default connect(state => {
  const molten = window.Molten;
  const prjId = molten.get('api').options.projectId;
  return {
    molten,
    maintenanceEvents: state.maintenanceEvents.active?.[prjId]?.maintenanceEvents
  };
})(MaintenanceReminders);